import aa, { InsightsMethodMap } from 'search-insights'

/**
 * A simple function for using Algolia's analytics and sending different events to it.
 * @example
 * const MyComponent = () => {
 *   return (
 *     <button onClick={() => trackAlgoliaAnalytics('eventName', data})}>
 *       Clear Value
 *     </button>
 *   )
 * }
 */

export const trackAlgoliaAnalytics = (
  event: keyof InsightsMethodMap,
  data: any
) => {
  aa('init', {
    appId: process.env.ALGOLIA_API_ID,
    apiKey: process.env.ALGOLIA_SEARCH_API_KEY
  })
  aa('setUserToken', sessionStorage.getItem('algoliaAnalyticsUser') as string)

  aa(event, data)
}
